import { render, staticRenderFns } from "./ContractViewLogs.vue?vue&type=template&id=672cd9e2&"
import script from "./ContractViewLogs.vue?vue&type=script&lang=js&"
export * from "./ContractViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports